import gql from "graphql-tag";

export const MY_DOCUMENTS_UPDATE_DOCUMENT = gql`
  mutation updateMyDocument(
    $_id: String!
    $description: String!
    $userView: Boolean!
  ) {
    updateMyDocument(_id: $_id, description: $description, userView: $userView)
  }
`;
